<template >
  <div
    class="container"
    style="direction: ltr; text-align: right; margin: 0 auto"
  >
    <!-- ******************************QUESTIONS*************************** -->

    <div v-if="newQuestion" class="text-right" style="margin: 0 auto">
      <div class="p-3 newQuestion">
        <form @submit.prevent="createNewQuestion" width="90%">
          <div class="form-group">
            <label for="question">שאלה</label>
            <input
              class="form-control"
              aria-describedby="question"
              placeholder="שאלה"
              name="question"
              dark
              label="question"
              id="question"
              v-model="question"
              required
            />
          </div>

          <div class="form-group">
            <label for="correctAnswer">תשובה נכונה </label>
            <input
              class="form-control"
              aria-describedby="correctAnswer"
              placeholder="תשובה נכונה"
              name="correctAnswer"
              dark
              label="correctAnswer"
              id="correctAnswer"
              v-model="correctAnswer"
              required
            />
          </div>
          <div class="form-group">
            <label for="wrongAnswer1">תשובה לא נכונה 1</label>
            <input
              class="form-control"
              aria-describedby="wrongAnswer1"
              placeholder="תשובה לא נכונה 1"
              name="wrongAnswer1"
              dark
              label="wrongAnswer1"
              id="wrongAnswer1"
              v-model="wrongAnswer1"
              required
            />
          </div>

          <div class="form-group">
            <label for="wrongAnswer2">תשובה לא נכונה 2</label>
            <input
              class="form-control"
              aria-describedby="wrongAnswer2"
              placeholder="תשובה לא נכונה 2"
              name="wrongAnswer2"
              dark
              label="wrongAnswer2"
              id="wrongAnswer2"
              v-model="wrongAnswer2"
              required
            />
          </div>

          <div class="form-group">
            <label for="wrongAnswer3">תשובה לא נכונה 3</label>
            <input
              class="form-control"
              aria-describedby="wrongAnswer3"
              placeholder="תשובה לא נכונה 3"
              name="wrongAnswer3"
              dark
              label="wrongAnswer3"
              id="wrongAnswer3"
              v-model="wrongAnswer3"
              required
            />
          </div>

          <div xs12>
            <button
              block
              type="submit"
              :loading="loading"
              outline
              class="btn btn-primary mt-5 btn-lg btn-block btn-sm"
            >
              שלח
              <span slot="loader" class="custom-loader"></span>
            </button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="questionSent" class="over">
      <div
        class="myModal row justify-content-center align-self-center"
        @click="questionSent = false"
      >
        <div class="h2 mb-4 text-center col-12 rtl" style="font-family: 'noot'">
          השאלה נשלחה בהצלחה
        </div>
        <div class="h3 mb-4 text-center col-12 rtl">תודה רבה</div>
        <div class="h2 mb-4 text-center col-12 rtl">לחצו כדי לסגור</div>
      </div>
    </div>
  </div>
</template>

<script>
// const exifparser = require("exif-parser");

export default {
  data() {
    return {
      questionSent: false,
      language: "Français",
      editing: false,
      endPoint: "",
      activePoint: null,
      activeQuestion: null,
      zoom: "",
      appExplaination: "",
      lng: "",
      lat: "",
      anniversary: false,
      randomQuestions: false,
      infoPage: false,
      navigationName: "EinDorShnatMitsva2022",
      showCreateNewNavigationGame: false,
      updateExistingOne: false,
      pointInformation: "",
      showNavigationKindChoices: false,
      navigationNumber: "",
      id: "",
      index: "",
      btnId: "btnId",
      key: "",
      e1: "recent",
      email: "",
      firstName: "",
      lastName: "",
      pointNumber: "",
      pointLinked: "",
      correctAnswer: "",
      wrongAnswer1: "",
      wrongAnswer2: "",
      wrongAnswer3: "",
      showUploadImage: true,
      imageUrl: "",
      showCanvas: false,
      image: null,
      pointsOrder: [],
      newPointToArray: "",
      missingWord: "",
      navigationKind: "",
      allQuestions: [],
      allPoints: [],
      question: "",
      newQuestion: true,
      newPoint: false,
    };
  },
  mounted() {
    this.$store.dispatch("fetchAllNavGames");
  },
  computed: {
    allNavGameNames() {
      var allNavGameNames = this.$store.getters.allNavGameNames;
      return allNavGameNames;
    },
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  methods: {
    saveQuestion(element) {
      element.editMode = false;
      const question = {
        // pointLinked: this.pointLinked,
        question: this.question,
        correctAnswer: this.correctAnswer,
        wrongAnswer1: this.wrongAnswer1,
        wrongAnswer2: this.wrongAnswer2,
        wrongAnswer3: this.wrongAnswer3,
      };
      console.log("create question", {
        question: question,
        navigationName: this.navigationName,
        key: element.results.key,
      });
      this.$store.dispatch("updatQuestion", {
        question: question,
        navigationName: this.navigationName,
        key: element.results.key,
      });
      // this.pointLinked = "";
      this.question = "";
      this.correctAnswer = "";
      this.wrongAnswer1 = "";
      this.wrongAnswer2 = "";
      this.wrongAnswer3 = "";
      this.$store.dispatch("fetchNavtigationData", this.navigationName);

      this.getAllQUestions();
    },

    createNewQuestion() {
      // this.newQuestion = false;
      this.questionSent = true;
      console.log("Create new question");
      const question = {
        // pointLinked: this.pointLinked,
        question: this.question,
        correctAnswer: this.correctAnswer,
        wrongAnswer1: this.wrongAnswer1,
        wrongAnswer2: this.wrongAnswer2,
        wrongAnswer3: this.wrongAnswer3,
      };
      var navigationName = this.navigationName;
      console.log("create question", {
        question: question,
        navigationName: navigationName,
      });
      this.$store.dispatch("createNewQuestion", {
        question: question,
        navigationName: navigationName,
      });
      // this.pointLinked = "";
      this.question = "";
      this.correctAnswer = "";
      this.wrongAnswer1 = "";
      this.wrongAnswer2 = "";
      this.wrongAnswer3 = "";
    },
  },
};
</script>

<style scoped>
input::placeholder {
  /* Firefox, Chrome, Opera */
  text-align: right;
}
.closeDiv {
  position: absolute;
  top: 0px;
  right: 0px;
  border-radius: 50px;
  height: 40px;
  width: 40px;
  font-size: 25px;
}
.newQuestion {
  position: relative;
  /* top: 0px; */
  /* left: 0px; */
  background: white;
  /* height: 94vh; */
  /* width: 94vw; */
  z-index: 2;
  /* margin-left: 3vw; */
  margin-top: 3vh;
  border: solid 4px red;
  overflow: hidden scroll;
  border-radius: 10px;
  z-index: 6;
  max-width: 590px;
}
.fabButton {
  position: fixed;
  bottom: 10px;
  right: 10px;
  border-radius: 50px;
  background: blue;
  padding: 0px;
}
.center {
  display: block;
  margin: 0px auto;
}
.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}
.colorBtn {
  border-radius: 36px;
  height: 56px;
  color: white;
}
.myModal {
  background: #2fcf17;
  min-height: 200px;
  overflow: auto;
  width: 300px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  color: white;
}
.over {
  position: absolute;
  top: 0px;
  font-size: 18px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 8;
}
.fitScreen {
  max-width: 100%;
}
.uploadPicture {
  border-style: dashed;
  border-color: grey;
  border-width: thin;
  height: 144px;
  margin: 0 auto;
}
.container {
  margin-top: 0px;
  background-color: rgba(255, 255, 255, 0);
  margin: 0px;
  padding: 0px;
}
</style>



